import { createSlice } from "@reduxjs/toolkit";
import { Api } from "../apis/api";

// Load stored tokens at startup
const storedTokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
const storedApiKey = JSON.parse(sessionStorage.getItem("api_key")) || null;

const initialState = {
  isAuthenticated: Boolean(storedTokens?.access_token),
  tokens: storedTokens,
  api_key: storedApiKey,
  user: null,
  status: "idle",
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { user, access_token, user_api_key, refresh_token } = action.payload;

      // Store tokens in a single object (clean and future-proof)
      const tokens = {
        access_token,
        refresh_token: refresh_token || null,
      };

      const api_key = {
        user_api_key,
      };

      state.user = user;
      state.tokens = tokens;
      state.api_key = api_key;
      state.isAuthenticated = true;

      // Persist session
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("tokens", JSON.stringify(tokens));
      sessionStorage.setItem("api_key", JSON.stringify(api_key));
    },
    logout: (state) => {
      // Clear slice state
      state.user = null;
      state.tokens = null;
      state.api_key = null;
      state.isAuthenticated = false;

      // Clear sessionStorage
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("tokens");
      sessionStorage.removeItem("api_key");
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("user_api_key");
    },
  },
});

export const logoutUser = () => (dispatch) => {
  dispatch(logout());
  dispatch(Api.util.resetApiState());
};

export const { setUser, logout } = authSlice.actions;
export default authSlice.reducer;